import React from 'react'
import "./AcceleratorEdit.scss"
import { Button, Col, Input, Row } from 'antd'
import trashIcon from "../../../Assets/Images/trashIcon.svg"
import plus from "../../../Assets/Images/plus.svg"

const AcceleratorEdit = () => {
    const { TextArea } = Input
    return (
        <div className='edit-container'>
            <div className="top-edit-section">
                <h6>Accelerator</h6>
                <div className="edit-right">
                    <Button className="cancel-btn"
                        onClick={"onSaveStartup"}
                    >
                        Cancel
                    </Button>
                    <Button className="save-btn"
                        onClick={"onSaveStartup"}
                    >
                        Save
                    </Button>
                </div>
            </div>
            <div className="accelerator-edit-wrap">
                <div className='inner-section'>

                    <div className="details-wrapper-section" style={{ background: '#F2F4F780' }}>
                        <h2>Founder 1</h2>
                        <Row gutter={24}>
                            <Col span={12}>
                                <div className="label">Full name</div>
                                <Input
                                    disabled
                                    className='inputs-box'
                                    value={"john smith"}
                                />
                            </Col>
                            <Col span={12}>
                                <div className="label">Email</div>
                                <Input
                                    disabled
                                    className='inputs-box'
                                    value={"johnsmith@gmail.com"}
                                />
                            </Col>
                            <Col span={24}>
                                <div className="label">Startup Website</div>
                                <Input
                                    disabled
                                    className='inputs-box'
                                    value={"Startup Website"}
                                />
                            </Col>
                            <Col span={24}>
                                <div className="label">Role & Skillset</div>
                                <TextArea
                                    disabled
                                    rows={3}
                                    bordered={0}
                                    className="text-area-box"
                                    value={"CFO; Strong background in finance, fundraising, and financial modeling. Expertise in managing budgets, forecasting, financial planning, and investor relations."}
                                />
                            </Col>
                            <Col span={24}>
                                <div className="label">Link</div>
                                <div className="linksSection">
                                    <Row gutter={24} style={{ display: 'flex', alignItems: 'center' }}>
                                        <Col span={6}>
                                            <Input
                                                className='inputs-box'
                                                value={"LinkedIn"}
                                            />
                                        </Col>
                                        <Col span={16}>
                                            <Input
                                                className='inputs-box'
                                                value={"linkedin.com/in/name"}
                                            />
                                        </Col>
                                        <Col span={2}>
                                            <img width={20} height={20} style={{ marginTop: '-20px' }} src={trashIcon} alt='trashIcon' />
                                        </Col>
                                    </Row>
                                    <Button className='add-button-edit'>
                                        <img src={plus} alt="plus" />
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <Button className='add-button' onClick={"handleAddCoInvestor"}>
                        <img src={plus} alt="plus" /> Add Founder</Button>

                    <div className="details-wrapper-section">
                        <h2>Your Idea</h2>
                        <Row gutter={24}>
                            <Col span={24}>
                                <div className="label">Startup name</div>
                                <Input
                                    className='inputs-box'
                                    value={"john smith"}
                                />
                            </Col>
                            <Col span={24}>
                                <div className="label">Who is it for?</div>
                                <TextArea
                                    rows={4}
                                    bordered={0}
                                    className="text-area-box"
                                    value={"Fundraising Pro is a platform designed to simplify the fundraising process for non-profits and startups, helping them connect with investors, donors, and funding sources."}
                                />
                            </Col>
                            <Col span={24}>
                                <div className="label">Why does it matter</div>
                                <TextArea
                                    rows={3}
                                    bordered={0}
                                    className="text-area-box"
                                    value={"Access to funding is one of the biggest hurdles faced by organizations, especially smaller ones. Fundraising Pro solves this by connecting them to the right sources, making the process faster and more efficient."}
                                />
                            </Col>
                            <Col span={24}>
                                <div className="label">What are you building</div>
                                <TextArea
                                    rows={4}
                                    bordered={0}
                                    className="text-area-box"
                                    value={"Fundraising Pro is a platform designed to simplify the fundraising process for non-profits and startups, helping them connect with investors, donors, and funding sources."}
                                />
                            </Col>
                        </Row>
                    </div>

                    <div className="details-wrapper-section">
                        <h1>Progress</h1>
                        <Row gutter={24}>
                            <Col span={24}>
                                <div className="label">Early steps taken</div>
                                <TextArea
                                    rows={5}
                                    bordered={0}
                                    className="text-area-box"
                                    value={"We’ve completed preliminary market research, conducted customer interviews, and created an early-stage prototype of the platform. We're currently testing the prototype with a small group of users."}
                                />
                            </Col>
                        </Row>
                    </div>

                    <div className="details-wrapper-section">
                        <h1>Vision</h1>
                        <Row gutter={24}>
                            <Col span={24}>
                                <div className="label">5-year vision</div>
                                <TextArea
                                    rows={5}
                                    bordered={0}
                                    className="text-area-box"
                                    value={"In five years, Fundraising Pro could become the go-to platform for organizations worldwide to access funding, providing a seamless, global network of investors, donors, and partners. We envision expanding to multiple industries, including tech startups, educational projects, and healthcare initiatives."}
                                />
                            </Col>
                        </Row>
                    </div>

                    <div className="details-wrapper-section">
                        <h1>Fit for Exitfund Accelerator</h1>
                        <Row gutter={24}>
                            <Col span={24}>
                                <div className="label">Why now?</div>
                                <TextArea
                                    rows={2}
                                    bordered={0}
                                    className="text-area-box"
                                    value={"With the increasing number of startups and non-profits needing funding solutions, the timing is perfect to scale Fundraising Pro and help address this urgent need."}
                                />

                            </Col>
                            <Col span={24}>
                                <div className="label">Why you?</div>
                                <TextArea
                                    rows={3}
                                    bordered={0}
                                    className="text-area-box"
                                    value={"My experience in both fundraising and technology makes me uniquely qualified to build a platform that meets the needs of both fundraisers and investors. I am passionate about helping organizations succeed."}
                                />
                            </Col>
                            <Col span={24}>
                                <div className="label">Why this program?</div>
                                <TextArea
                                    rows={2}
                                    bordered={0}
                                    className="text-area-box"
                                    value={"Exitfund Accelerator offers the expertise and network to help scale our solution quickly. Their focus on early-stage startups and growth matches our current needs and future aspirations."}
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className="details-wrapper-section">
                        <h1>Founder Introduction Video</h1>
                        <Row gutter={24}>
                            <Col span={24}>
                                <div className="label">Link to a short 60-second founder intro video</div>
                                <Input
                                    className='inputs-box'
                                    value={"Url"}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AcceleratorEdit